import script from "./PurchaseRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseRecord.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseRecord.vue?vue&type=style&index=0&id=59921870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59921870"]])

export default __exports__